"use strict";

exports.__esModule = true;
exports.Schema = void 0;
const Schema = exports.Schema = {
  make: ({
    id = '',
    fields = {}
  } = {}) => ({
    id,
    fields
  }),
  makeField: ({
    type = 'text'
  } = {}) => ({
    type
  }),
  getFieldType: (schema, fieldName) => {
    if (!schema.fields) {
      return undefined;
    }
    const [_, {
      type
    } = {}] = Object.entries(schema.fields).find(([key]) => key === fieldName) ?? [];
    return type;
  }
};
//# sourceMappingURL=schema.js.map